
// import React from "react";
// import Header from "../../components/Header/Header";
// import Navbar from "../../components/NavBar/NavBar";
// import data from "../../screens/Home/product.json";
// import ItemList from "../../components/ItemList/ItemList";
// import Footer from '../../components/Footer/Footer';
// import ProductDiscription from "../../screens/ProductDiscription/ProductDiscription";

// function AsaanOrder() {

//   const [data, setData] = useState(null);
//   const [fullScreen, setFullScreen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   return (
//     <div>
//       <Header />
//       <Navbar />
//       <div style={{ marginTop: "5%" }}>
//         {/* <ItemList data={data} /> */}
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default AsaanOrder;

import data from "../../screens/Home/product.json";
import ItemList from "../../components/ItemList/ItemList";
import ProductDiscription from "../../screens/ProductDiscription/ProductDiscription";
import React, { useState, useEffect } from "react";
import { TextField, Checkbox } from "@mui/material";
import "../AsaanOrder/AsaanOrder.css";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import NavBar from "../../components/NavBar/NavBar";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Button } from "reactstrap";


function LabTest() {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState(null);
  const [fullScreen, setFullScreen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event) => {
    const { target } = event;
    const { files } = target;

    if (files && files[0]) {
      const reader = new FileReader();

      reader.onloadstart = () => setLoading(true);

      reader.onload = (event) => {
        setData(event.target.result);
        setLoading(false);
      };

      reader.readAsDataURL(files[0]);
    }
  };

  const handlePreviewClick = () => {
    if (!data) {
      return;
    }

    setFullScreen(!fullScreen);
  };

  const backgroundImage = data ? { backgroundImage: `url(${data})` } : null;
  const previewClasses = [
    "preview",
    fullScreen ? "preview--fullscreen" : "",
  ].join(" ");

  return (
    <>
      <Header />
      <NavBar />

      <div className="checkout-containerAssan">
        <div className="cartAssan" style={{ borderRadius: 5 }}>
          <center>
            <h3 className="ordermedicineAssan">
              Lab Report Process
            </h3>

            <div className="flexRowAssan">
              <div className="circle">
                <img
                  src={require("../../assets/prescr-box.png")}
                  alt=""
                  className="imageAssan"
                />
                <p className="textInfo">Upload Test Reports Name</p>
              </div>
              <div className="HorizentalRow" />
              <div className="circle">
                <img
                  src={require("../../assets/prescr-phone.png")}
                  alt=""
                  className="imageAssan"
                />
                <p className="textInfo">Receive a confirmation call</p>
              </div>
              <div className="HorizentalRow" />
              <div className="circle">
                <img
                  src={require("../../assets/prescr-rx.png")}
                  alt=""
                  className="imageAssan"
                />
                <p className="textInfo">Person for at your doorstep</p>
              </div>
            </div>
          </center>
          <form>
            <h3 className="">Upload Prescription</h3>
            <input
              id="car"
              type="file"
              accept="image/*"
              capture="camera"
              onChange={handleFileChange}
            />
            <div
              className={previewClasses}
              style={backgroundImage}
              onClick={handlePreviewClick}
            >
              {!data && !loading && (
                <label htmlFor="car">Upload doctor prescription</label>
              )}
              {loading && <span>Loading...</span>}
            </div>
            <div style={{display:'flex', justifyContent:'flex-end',marginTop:'4%'}}>
            <Link to="/ContactSoon">
              <Button color="primary" style={{borderRadius:'10px'}}>Submit</Button>
              </Link>
            </div>
          </form>
        </div>

        <div className="cartAssan" style={{ borderRadius: 5 }}>
          <center>
            <h3 className="ordermedicineAssan">
              HOW TO UPLOAD YOUR PRESCRIPTION?
            </h3>
            <p style={{ fontSize: 13, lineHeight: 1.5 }}>
              Do not crop out any part of the prescription image. Avoid unclear
              or blurred image of your prescription. Include details of your
              doctor, patient and clinic visit date. Medicines will only be
              dispensed against a valid prescription.
            </p>
            <img
              src={require("../../assets/prescr-upload.jpg")}
              alt=""
              className="prescr-upload"
            />
          </center>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default LabTest;
